// エントリポイント
import "maplibre-gl/dist/maplibre-gl.css";
import "./style.css";
import { HanabiApp } from "./app";

const app = new HanabiApp();
app.start().catch((err) => {
  console.error(err);
  const sub = document.getElementById("loaderSub");
  if (sub) sub.textContent = "起動に失敗しました。コンソールを確認してください。";
});
